/* eslint-disable react/jsx-key */
import clsx from 'clsx';
import { ItemWithId } from 'components/table/types';
import { Row } from 'react-table';

type Props<T extends ItemWithId> = {
  row: Row<T>;
  rowClassName?: string;
};

const CustomRow = <T extends ItemWithId>({ row, rowClassName }: Props<T>) => (
  <tr {...row.getRowProps()} className={rowClassName}>
    {row.cells.map((cell) => {
      return (
        <td {...cell.getCellProps()} className={clsx({ 'min-w-100px': cell.column.id === 'actions' })}>
          {cell.render('Cell')}
        </td>
      );
    })}
  </tr>
);

export { CustomRow };
